import { addCarData, setDataOption, initOption } from '@/mapTools'

const buildFun = function (parm) {
  let renderBrushed = function (params) {
    console.log(parm)
    let legendData = parm === 'tobacco' ? ['红塔山', '玉溪', '云烟'] : (parm === 'shop' ? ['干货', '新鲜货', '冰冻货'] : ['0号柴油', '92号汽油', '95号汽油'])
    let mainSeries = params.batch[0].selected[0]
    let seriesData = window.myChat.getOption().series[0].data
    let selectedItems = []
    let categoryData = []
    let barData = []
    let maxBar = 10
    let sum = 0
    let count = 0
    for (let i = 0; i < mainSeries.dataIndex.length; i++) {
      let rawIndex = mainSeries.dataIndex[i]
      let dataItem = seriesData[rawIndex]
      let pmValue = dataItem.value[2].dry + dataItem.value[2].fresh + dataItem.value[2].frozen
      sum += pmValue
      count++
      selectedItems.push({
        name: dataItem.name,
        value: [dataItem.value[2].dry, dataItem.value[2].fresh, dataItem.value[2].frozen]
      })
    }
    selectedItems.sort(function (a, b) {
      return b.value[2] - a.value[2]
    })
    barData = [{
      id: 'bar1',
      type: 'bar',
      stack: '总量',
      name: legendData[0],
      data: [],
      tooltip: {
        trigger: 'item',
        formatter: function (params) {
          return params.seriesName + '<br/>' + params.data
        }
      }
    },
    {
      id: 'bar2',
      type: 'bar',
      stack: '总量',
      name: legendData[1],
      data: [],
      tooltip: {
        trigger: 'item',
        formatter: function (params) {
          return params.seriesName + '<br/>' + params.data
        }
      }
    },
    {
      id: 'bar' + i,
      type: 'bar',
      stack: '总量',
      name: legendData[2],
      data: [],
      tooltip: {
        trigger: 'item',
        formatter: function (params) {
          return params.seriesName + '<br/>' + params.data
        }
      }
    }]
    for (var i = 0; i < Math.min(selectedItems.length, maxBar); i++) {
      categoryData.push(selectedItems[i].name)
      barData[0].data.push(selectedItems[i].value[0])
      barData[1].data.push(selectedItems[i].value[1])
      barData[2].data.push(selectedItems[i].value[2])
    }
    window.myChat.setOption({
      xAxis: {
        axisLabel: {
          show: !!count
        }
      },
      yAxis: {
        data: categoryData,
        type: 'category',
        show: !!count,
        axisLine: {
          lineStyle: {
            color: '#fff'
          }
        }
      },
      grid: {
        left: '13%',
        bottom: '5%',
        height: '30%',
        width: '20%'
      },
      title: {
        id: 'title_select',
        text: count ? '平均: ' + (sum / count).toFixed(2) : ''
      },
      series: barData
    })
  }
  return renderBrushed
}

const state = {
  // 0开始 1初始化完成 2 option设置完成 -1 离开页面
  chat_status: 0,
  db_chat: null,
  map_data_customer: [],
  all_day_map_customer: [],
  all_map_data_customer: [],
  map_data_plant: [],
  map_data_center: [],
  map_data_route: []
}

const getters = {
  dbChat: state => state.db_chat,
  mapDataCustomer: state => state.map_data_customer,
  allMapDataCustomer: state => state.all_map_data_customer,
  mapDataPlant: state => state.map_data_plant,
  mapDataCenter: state => state.map_data_center
}

const actions = {
  clearMapOption ({ commit, getters, dispatch }) {
    let dataP = null
    if (getters.sourceDataType === 'shop') {
      dataP = {
        legendData: ['客户', '工厂', '中心点'],
        row: ['干货', '新鲜货', '冰冻货']
      }
    } else if (getters.sourceDataType === 'tobacco') {
      dataP = {
        legendData: ['商店', '卷烟配送中心', '中心点'],
        row: ['红塔山', '玉溪', '云烟']
      }
    } else {
      dataP = {
        legendData: ['加油站', '油库', '中心点'],
        row: ['0号柴油', '92号汽油', '95号汽油']
      }
    }
    window.myChat.clear()
    window.myChat.setOption(initOption(dataP), true)
    window.myChat.on('brushselected', buildFun(getters.sourceDataType))
  },
  initMapOption ({ commit, getters, dispatch }) {
    window.myChat.clear()
    let dataP = null
    if (getters.sourceDataType === 'shop') {
      dataP = {
        legendData: ['客户', '工厂', '中心点'],
        row: ['干货', '新鲜货', '冰冻货']
      }
    } else if (getters.sourceDataType === 'tobacco') {
      dataP = {
        legendData: ['商店', '配送中心', '中心点'],
        row: ['红塔山', '玉溪', '云烟']
      }
    } else {
      dataP = {
        legendData: ['加油站', '油库', '中心点'],
        row: ['0号柴油', '92号汽油', '95号汽油']
      }
    }
    window.myChat.setOption(initOption(dataP), true)
    dispatch('setChatStatus', 2)
  },
  setAllMapDataCustomer ({ commit }, data) {
    commit('changeAllMapDataCustomer', data)
  },
  setChatStatus ({ commit }, data) {
    commit('changeChatStatus', data)
  },
  selectMapDataCustomer  ({ commit }, data) {
    commit('changeSelectMapDataCustomer', data)
  },
  selectMapCarCustomer  ({ commit, getters }, data) {
    commit('changeSelectMapCarCustomer', {clusterCutomer: getters.clusterCutomer, ...data})
  },
  setOption ({ commit }, data) {
    commit('changeOption', data)
  },
  setDbChat ({ commit }, data) {
    commit('changeDbChat', data)
  },
  setMapDataCustomer ({ commit }, data) {
    commit('changeMapDataCustomer', data)
  },
  setMapDataPlant ({ commit }, data) {
    commit('changeMapDataPlant', data)
  },
  setMapDataCenter ({ commit }, data) {
    commit('changeMapDataCenter', data)
  },
  setMapDataRoute ({ commit }, data) {
    commit('changeMapDataRoute', data)
  }
}

const mutations = {
  changeChatStatus (state, data) {
    state.chat_status = data
    if (data === 2) {
      let optionList = [{
        key: 'Location',
        data: state.map_data_customer
      },
      {
        key: 'Plant',
        data: state.map_data_plant
      },
      {
        key: 'centroids',
        data: state.map_data_center
      }]
      optionList.forEach(function (item) {
        setDataOption(item.key, item.data)
      })
      addCarData(window.myChat, state.map_data_route)
    }
  },
  changeOption (state, data) {
    state.db_chat = data
  },
  changeDbChat (state, data) {
    state.db_chat = data
  },
  changeMapDataCustomer (state, data) {
    if (state.chat_status === 2) {
      setDataOption('Location', data)
    }
    state.map_data_customer = data
  },
  changeSelectMapDataCustomer (state, data) {
    let newData = []
    state.all_map_data_customer.forEach(function (item) {
      if (item.order_days && item.order_days.indexOf(data) > -1 || !data) {
        newData.push(item)
      }
    })
    state.all_day_map_customer = newData
    state.map_data_customer = newData
    if (state.chat_status === 2) {
      setDataOption('Location', newData)
    }
  },
  changeSelectMapCarCustomer (state, data) {
    let custormer = []
    data.clusterCutomer.forEach(function (item) {
      if (item[0].slice(2) === data.car.slice(2)) {
        custormer = item.slice(1)
        return
      }
    })
    if (data.status) {
      let newData = []
      state.map_data_customer.forEach(function (item) {
        newData.push(item)
      })
      // 提取数据后加进去
      state.all_day_map_customer.forEach(function (item) {
        if (custormer.indexOf(item.name) > -1) {
          newData.push(item)
        }
      })
      state.map_data_customer = newData
    } else {
      // 直接从map_data_customer中删去
      let newData = []
      state.map_data_customer.forEach(function (item) {
        if (custormer.indexOf(item.name) === -1) {
          newData.push(item)
        }
      })
      state.map_data_customer = newData
    }
    if (state.chat_status === 2) {
      setDataOption('Location', state.map_data_customer)
    }
  },
  changeMapDataPlant (state, data) {
    if (state.chat_status === 2) {
      setDataOption('Plant', data)
    }
    state.map_data_plant = data
  },
  changeAllMapDataCustomer (state, data) {
    state.all_map_data_customer = data
  },
  changeMapDataCenter (state, data) {
    if (state.chat_status === 2) {
      setDataOption('centroids', data)
    }
    state.map_data_center = data
  },
  changeMapDataRoute (state, data) {
    if (state.chat_status === 2) {
      addCarData(window.myChat, data)
    }
    state.map_data_route = data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/db_map.js